import React from 'react'
import classNames from 'classnames'
import FocusTrap from 'focus-trap-react'
import usePortal from 'react-cool-portal'
import CloseButton from '../CloseButton'
import styles from './BaseModal.module.scss'

export interface BaseModalProps {
  children: React.ReactNode
  open: boolean
  toggle?: () => void
  className?: string
}

const BaseModal = ({ children, toggle, open, className }: BaseModalProps) => {
  const { Portal } = usePortal({
    containerId: 'analyzeModalRoot',
    defaultShow: true,
  })

  let wrapper

  if (!open) {
    return null
  }

  return (
    open && (
      <Portal>
        <FocusTrap
          focusTrapOptions={{
            fallbackFocus: () => wrapper,
            clickOutsideDeactivates: true,
          }}
        >
          <TrapChild
            ref={ref => (wrapper = ref)}
            toggle={toggle}
            open={open}
            className={className}
          >
            {children}
          </TrapChild>
        </FocusTrap>
      </Portal>
    )
  )
}

export type Ref = HTMLElement

export interface TrapChildProps {
  children: React.ReactNode
  open: boolean
  toggle?: () => void
  className?: string
}

const TrapChild = React.forwardRef<Ref, TrapChildProps>(
  ({ children, toggle, open, className }, ref) => {
    return (
      <main
        ref={ref}
        role='dialog'
        aria-modal={open}
        aria-labelledby='dialog-title'
        className={classNames(styles.modal, className)}
      >
        <CloseButton
          className={styles.button}
          onClick={e => {
            toggle?.()
            e.preventDefault()
          }}
        />
        <div className={styles.container}>{children}</div>
      </main>
    )
  }
)

export default BaseModal
